import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import './scrollbars.css';
import reportWebVitals from './reportWebVitals.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

reportWebVitals();
